import { Component } from '@angular/core';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';
declare var $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'HVF Admin';

  public LoginDetail: any = [];
  public loginTrue: boolean = false;
  public CurrentUrl:any ='';
  public loading:boolean = false;

  constructor(public router: Router, private service: GlobalService) { 
  }

  ngOnInit() {   
  }

  changeRoute() { 
    this.CurrentUrl =this.router.url;   
    if (localStorage.getItem("hva_login")) {
      this.LoginDetail = JSON.parse(localStorage.getItem("hva_login") || "{}");
      this.service.setSubject(this.LoginDetail);
      if(this.CurrentUrl != '/booking' &&  this.CurrentUrl != '/category' && this.CurrentUrl != '/transaction'  && this.CurrentUrl != '/user-listing' && this.CurrentUrl != '/user-detail' && this.CurrentUrl != '/booking-detail' && this.CurrentUrl != '/transaction-detail' ){
        localStorage.removeItem('hva_filter');
      }
    } 
    if(this.CurrentUrl == '/signin' || this.CurrentUrl == '/' ){
      $('#beforeLoginbg').addClass('bg-login')
    } else {
      $('#beforeLoginbg').removeClass('bg-login')
    }
  }
}
